export { default } from './svg/banner-image.svg';
